import React from "react";
import { connect } from "react-redux";
import ReactGA from "react-ga";
import Configuration from "../config";

import { message, setTitleAndScrollToTop } from "../actions";
import { createUser, deleteUser, getUsersOverview, patchUser, resetMonthlyLimit, setMonthlyLimit } from "../actions/Users";

import Form from "../components/Form";
import Icon from "../components/Icon";
import Access from "../components/Access";
import Modal from "../components/Modal";
import QuestionnairePriceBox from "../plugins/questionnaires/components/PriceBox";
import Overview from "../components/Overview";
import { getUpdatedValues } from "../components/HandleHelper";

const mapStateToProps = ( state ) =>
{
	return {
		user: state.user,
		users: state.users,
		userCount: state.userCount,
		organizations: state.organizations,
		roles: state.roles
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getUsersOverview: () =>
		{
			dispatch( getUsersOverview() );
		},
		createUser: ( formData ) =>
		{
			dispatch( createUser( formData ) );
		},
		patchUser: ( formData ) =>
		{
			dispatch( patchUser( formData ) );
		},
		deleteUser: ( formData ) =>
		{
			dispatch( deleteUser( formData ) );
		},
		setTitleAndScrollToTop: ( title ) =>
		{
			dispatch( setTitleAndScrollToTop( title ) );
		},
		setMonthlyLimit: ( formData ) =>
		{
			dispatch( setMonthlyLimit( formData ) );
		},
		resetMonthlyLimit: () =>
		{
			dispatch( resetMonthlyLimit() );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 *
 * RETODO Um die Filterfunktion zu erhalten, sollte die Overview Komponente verwendet werden (siehe OrganizationManagement)
 */
class UserManagement extends React.Component
{
	constructor( props )
	{
		super( props );
		
		// geschützte Benutzer vom Löschen ausschließen
		this.state = {
			protectedUser: {
				"support@esch.design": true,
				"role-admin@esch.design": true,
				"orga-admin@esch.design": true,
				"admin@esch.design": true,
				"cert@esch.design": true,
				"benutzer@esch.design": true,
				"fakt-admin@esch.design": true
			},
			isExpand: {}
		};
		
		// Für nicht Support Nutzer die Organisation aufklappen
		if ( !Access.isPermitted( props.user, [ "get_organizations" ] ) )
		{
			// aktive und inaktive anzeigen
			this.state.isExpand[ `${props.user.organization.id}_1` ] = true;
			this.state.isExpand[ `${props.user.organization.id}_0` ] = true;
		}
		
		this.handleSubmit = this.handleSubmit.bind( this );
		this.handleDelete = this.handleDelete.bind( this );
		this.handleExpand = this.handleExpand.bind( this );
		
	} // function constructor(...)
	
	componentDidMount()
	{
		const props = {};
		if ( Configuration.pluginName === "questionnaires" )
		{
			props[ "className" ] = "col s12 l8 white-text";
			props[ "style" ] = { margin: "45px 0 -25px" };
		}
		
		if ( Configuration.pluginName === "reports" )
		{
			props[ "className" ] = "col s12 l8 primary-color-text margin-top padding-top";
		}
		
		this.props.setTitleAndScrollToTop( <h1 {...props}>Benutzerverwaltung</h1> );
		
		if ( this.props.users.length === 0 && Access.isPermitted( this.props.user, [ "get_users" ] ) )
		{
			this.props.getUsersOverview();
		}
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( "/benutzerverwaltung" );
		}
		
	} // function componentDidMount()
	
	/**
	 * Einen Organisationsblock ein-/ausklappen
	 */
	handleExpand( block_id )
	{
		let is_expand = Object.assign(
			{},
			this.state.isExpand,
			{
				[ block_id ]: !this.state.isExpand[ block_id ]
			}
		);
		this.setState( { isExpand: is_expand } );
		
	} // function handleExpand(...)
	
	handleSubmit( a_event, a_form_ref, a_mode )
	{
		a_event.preventDefault();
		
		if ( this.refs.hasOwnProperty( a_form_ref ) )
		{
			const formData = this.refs[ a_form_ref ].state;
			
			switch ( a_mode )
			{
				case "create":
					this.props.createUser( formData );
					break;
				
				/*case "edit":
				 this.props.patchUser( { ...formData, role: this.props.roles[ formData.role_id ].name } );
				 break;*/
				
				default:
					break;
			}
		}
		
		return false;
		
	} // function handleSubmit(...)
	
	/**
	 * Aktion: Benutzer ändern
	 *
	 * @param {Object} a_currentValues  Aktuelle Domaindaten
	 * @param {Object} a_newValues      Neue Domaindaten
	 */
	handleEdit( a_currentValues, a_newValues )
	{
		if ( JSON.stringify( a_currentValues ) !== JSON.stringify( a_newValues ) )
		{
			const updatedValues = getUpdatedValues( a_currentValues, a_newValues );
			
			if ( Object.keys( updatedValues ).length === 0 )
			{
				return this.props.message( "Es liegen keine Änderungen vor." );
			}
			
			// Nur die Änderungen aktualisieren
			this.props.patchUser( updatedValues );
		}
		
	} // function handleEdit(...)
	
	handleDelete( a_user )
	{
		if ( parseInt( a_user.id ) === parseInt( this.props.user.id ) )
		{
			return this.props.message( "Es ist Ihnen nicht gestattet, sich selbst zu löschen.", "error" );
		}
		
		this.props.deleteUser( a_user );
		
	} // function handleDelete(...)
	
	renderUsers( userKeys, title, titleColor = "primary-color" )
	{
		const { organizations, users, user, roles } = { ...this.props };
		
		let lastOrganizationId = null;
		let organizationBreak = null;
		const organizationOptions = organizations
			? Object.keys( organizations ).map( a_key =>
			{
				return { value: a_key, title: organizations[ a_key ].name };
			} )
			: {};
		const roleOptions = roles
			? Object.keys( roles ).map( a_key =>
			{
				return { value: a_key, title: roles[ a_key ].name };
			} )
			: {};
		
		return (
			organizations &&
			<ul key={`${title.replace( " ", "_" )}_user_list`} className={"collection margin-top margin-bottom"}>
				<li key={`users_header_${title}`} className={`collection-item userSpacer white-text ${titleColor}`}>
					<h6>{`${title} ( ${userKeys.length} )`}</h6>
				</li>
				{
					userKeys.length > 0 &&
					userKeys.map(
						( a_key ) =>
						{
							if ( users[ a_key ] == null )
							{
								return [];
							}
							
							const selectedUser = users[ a_key ];
							const organization = organizations.hasOwnProperty( selectedUser.organization_id ) ? organizations[ selectedUser.organization_id ] : user.organization;
							
							if ( selectedUser.organization_id !== lastOrganizationId )
							{
								lastOrganizationId = selectedUser.organization_id;
								organizationBreak = true;
							}
							else
							{
								organizationBreak = false;
							}
							
							return [
								<Access key={`organization_sub_header_${selectedUser.organization_id}_${selectedUser.is_active}`} permissions={[ "get_organizations" ]}>
									{
										organizationBreak &&
										<li className={"collection-item organizationSpacer item-spacer lighter-grey pointer"}
										    onClick={() => this.handleExpand( `${selectedUser.organization_id}_${selectedUser.is_active}` )}>
											<div className="actions actions-right">
												<button className="btn btn-small btn-flat hover-light-grey right"
												        key={`block_expand_id_${selectedUser.organization_id}_${selectedUser.is_active}`}>
													<Icon
														iconName={this.state.isExpand[ `${selectedUser.organization_id}_${selectedUser.is_active}` ] ? "shrink" : "expand"}/>
												</button>
											</div>
											{organization.name}<br/>
											<label className={"label-grey-text"}>
												{`${organization.street} ${organization.street_number}, ${organization.postal_code} ${organization.city}`}
												{
													// `Aktuelle Kosten excl. Grundgebühr:
													// ${( organization.survey_costs || organization.survey_costs === 0 ) &&
													// parseFloat( organization.survey_costs ).toLocaleString( Configuration.location, Configuration.priceString )} Euro`
												}
											</label>
										</li>
									}
								</Access>,
								this.state.isExpand[ `${selectedUser.organization_id}_${selectedUser.is_active}` ] &&
								<li key={`user_id_${selectedUser.id}`} className={"collection-item itemSpacer white-grey"}>
									<div className="col s10 xl10">
										<div className={"col xl1"}>
											<label>Anrede</label><br/>
											{`${selectedUser.sex === "m" ? "Herr" : selectedUser.sex === "f" ? "Frau" : ""}`}
										</div>
										<div className={"col xl3"}>
											<label>Vorname, Nachname</label><br/>
											{selectedUser.forename} {selectedUser.surname}
										</div>
										<div className={"col xl3"}>
											<label>E-Mail</label><br/>
											{selectedUser.email}
										</div>
										<div className={"col xl3"}>
											<label>Benutzer seit{selectedUser.is_active === "1" && selectedUser.last_login ? ", letzte Anmeldung" : ""}</label><br/>
											{selectedUser.created_at ? new Date( selectedUser.created_at ).toLocaleString( Configuration.location, Configuration.dateString ) + " Uhr" : ""}<br/>
											{
												selectedUser.is_active === "1" && selectedUser.last_login
													? new Date( selectedUser.last_login ).toLocaleString( Configuration.location, Configuration.dateString ) + " Uhr"
													: ""
											}
										</div>
										<div className={"col xl2"}>
											<label>Rolle</label><br/>
											{selectedUser.role}
										</div>
									</div>
									<div className={"col s12 xl2 icon-bar tRight"}>
										<Form
											id={`formEditUser${selectedUser.id}`}
											ref={`formEditUser${selectedUser.id}`}
											
											modalTrigger={
												<button className={"btn btn-middle white primary-color-text hover-primary-color hover-white-text icon-shadow"}>
													<Icon verticalAlign={"middle"} size={18} iconName={"edit"}/>
												</button>
											}
											modalClass={"tLeft"}
											modalTitle={"Benutzer ändern"}
											
											className="col s12"
											errorMessage={( a_message, a_type, a_timeout ) => this.props.message( a_message, a_type, a_timeout )}
											onSubmit={( event ) => this.handleSubmit( event, `formEditUser${selectedUser.id}`, "edit" )}
											submitValue={[
												<Icon key={`form-edit-user-${selectedUser.id}-icon`} iconName={"edit"}/>,
												<span key={`form-edit-user-${selectedUser.id}-text`}>Benutzer ändern</span>
											]}
											fields={[
												{
													name: "sex",
													title: "Anrede",
													type: "select",
													options: [
														{ value: "n", title: "keine" },
														{ value: "m", title: "Herr" },
														{ value: "f", title: "Frau" }
													],
													required: true,
													className: "col s6",
													cleared: true
												},
												{
													name: "forename",
													title: "Vorname",
													type: "text",
													required: true,
													className: "col s6",
													maxLength: "50"
												},
												{
													name: "surname",
													title: "Nachname",
													type: "text",
													required: true,
													className: "col s6",
													maxLength: "50"
												},
												{
													name: "role_id",
													title: "Rolle",
													type: "select",
													options: roleOptions,
													required: true,
													disabled: this.state.protectedUser.hasOwnProperty( selectedUser.email ),
													className: "col s6"
												},
												{
													name: "organization_id",
													title: "Organisation",
													type: "select",
													options: organizationOptions,
													disabled: this.state.protectedUser.hasOwnProperty( selectedUser.email ),
													required: true,
													className: "col s6"
												}
											]}
											values={selectedUser}
										/>
										{
											selectedUser.id !== user.id.toString() &&
											!this.state.protectedUser.hasOwnProperty( selectedUser.email )
												? <Access permissions={[ "delete_user" ]}>
													<Modal
														className={"confirm"}
														key={`user_delete_id_${selectedUser.email}`}
														trigger={<button className="btn btn-middle white hover-red red-text hover-white-text icon-shadow"
														                 key={`user_delete_id_${selectedUser.email}`}>
															<Icon verticalAlign={"middle"} size={18} iconName={"delete"}/>
														</button>}
														footer={
															<React.Fragment>
																<button onClick={( event ) => this.handleDelete( event, selectedUser )} data-modal={"confirm"}>
																	<Icon size={14} iconName={"delete"}/><span>Benutzer löschen</span>
																</button>
																<button className={"secondary-color"} data-modal={"close"}><Icon iconName={"discard"}/><span>abbrechen</span></button>
															</React.Fragment>
														}
													>
														<p className={"tCenter"}>Soll der Benutzer <strong>{selectedUser.forename} {selectedUser.surname}</strong> mit der
															E-Mail-Adresse <strong>{selectedUser.email}</strong> wirklich gelöscht werden?</p>
													</Modal>
												</Access>
												: <button className="btn btn-middle grey-text white hover-white icon-shadow disabled button"
												          key={`user_delete_id_${selectedUser.email}`}>
													<Icon verticalAlign={"middle"} size={18} iconName={"delete"}/>
												</button>
										}
									</div>
								</li>
							];
						}
					)
				}
			</ul> );
		
	} // function renderUsers(...)
	
	render()
	{
		const { user, users, organizations, roles, userCount } = { ...this.props };
		
		const userKeys = users ? Object.keys( users ) : {};
		const organizationOptions = organizations
			? Object.keys( organizations ).map( a_key =>
			{
				return { value: a_key, title: organizations[ a_key ].name };
			} )
			: {};
		const roleOptions = roles
			? Object.keys( roles ).map( a_key =>
			{
				return { value: a_key, title: roles[ a_key ].name };
			} )
			: {};
		const values = { organization_id: user.organization.id };
		
		// Wenn nur eine Rolle zur Auswahl steht, dann diese auswählen
		if ( Object.keys( roleOptions ).length === 1 )
		{
			values[ "role_id" ] = roleOptions[ 0 ].value;
		}
		
		const currentUserCount = users && Object.keys( users ).length;
		const addUser = userCount === "unlimited" ||
			( userCount > 0 && userKeys.length > 0 && userCount > userKeys.length );
		
		// Ermittlung der aktiven/inaktiven Benutzer Ids
		let activeUsersIds = [];
		let inactiveUsersIds = [];
		userKeys.length > 0 && userKeys.forEach(
			( a_user_id ) =>
			{
				users[ a_user_id ].is_active === "1" ? activeUsersIds.push( a_user_id ) : inactiveUsersIds.push( a_user_id );
			}
		);
		
		
		let userOverview = [], inactiveUserOverview = [], customerOverview = [], inactiveCustomerOverview = [];
		
		const editFields = [
			{
				name: "sex",
				title: "Anrede",
				type: "select",
				options: [
					{ value: "n", title: "keine" },
					{ value: "m", title: "Herr" },
					{ value: "f", title: "Frau" }
				],
				required: true,
				className: "col s4 l2"
			},
			{
				name: "forename",
				title: "Vorname",
				type: "text",
				required: true,
				className: "col s4 l5",
				maxLength: "50"
			},
			{
				name: "surname",
				title: "Nachname",
				type: "text",
				required: true,
				className: "col s4 l5",
				maxLength: "50",
				cleared: true
			},
			{
				name: "role_id",
				title: "Rolle",
				type: "select",
				options: roleOptions,
				required: true,
				className: "col s6"
			},
			{
				name: "organization_id",
				title: "Organisation",
				type: "select",
				options: organizationOptions,
				required: true,
				className: "col s6"
			}
		];
		
		const listFields = [
			{
				name: "sex",
				title: "Anrede",
				format: "sex",
				className: "col xl1"
			},
			{
				name: [ "forename", "surname" ],
				title: "Vorname Nachname",
				className: "col xl3"
			},
			{
				name: "email",
				title: "E-Mail",
				className: "col xl3"
			},
			{
				name: [ [ "created_at" ], [ "last_login" ] ],
				title: "Benutzer seit, letzte Anmeldung",
				className: "col xl3"
				// name: [ "created_at", "last_login" ],
				// fieldValueClassName: [ "main-text", "sub-text" ]
			},
			{
				name: "role_id",
				title: "Rolle",
				format: "options",
				options: roleOptions,
				className: "col xl2"
			}
		];
		
		Object.keys( users ).forEach(
			a_id =>
			{
				const currentUser = { ...users[ a_id ] };
				currentUser[ "created_at" ] = currentUser.created_at ? new Date( currentUser.created_at ).toLocaleString( Configuration.location, Configuration.dateString ) + " Uhr" : null;
				currentUser[ "last_login" ] = currentUser.last_login ? new Date( currentUser.last_login ).toLocaleString( Configuration.location, Configuration.dateString ) + " Uhr" : null;
				
				if ( currentUser.organization_id === user.organization.id )
				{
					if ( currentUser.is_active === "1" )
					{
						userOverview.push( currentUser );
					}
					else
					{
						inactiveUserOverview.push( currentUser );
					}
				}
				else if ( Access.isPermitted( user, [ "get_restricted_users" ] ) && Object.keys( organizations ).length > 0 )
				{
					currentUser[ "organization" ] = organizations[ currentUser.organization_id ];
					currentUser[ "organization_name" ] = currentUser.organization && currentUser.organization.name;
					if ( currentUser.is_active === "1" )
					{
						customerOverview.push( currentUser );
					}
					else
					{
						inactiveCustomerOverview.push( currentUser );
					}
				}
			}
		);
		
		const trigger = [
			{
				key: "editUser",
				icon: "edit",
				submitButtonText: "Ändern",
				title: "Benutzer ändern",
				iconTitle: "Benutzer ändern",
				iconClassName: "white primary-color-text hover-primary-color hover-white-text",
				permissions: [ "patch_user" ],
				formFields: editFields,
				onClick: ( a_currentValues, a_newValues ) => this.handleEdit( a_currentValues, a_newValues )
			},
			{
				key: "deleteUser",
				icon: "delete",
				submitButtonText: "Löschen",
				title: "Benutzer löschen",
				iconTitle: "Benutzer löschen",
				iconClassName: "white red-text hover-red hover-white-text",
				permissions: [ "delete_user" ],
				additionalModalHtml: <p className={"tCenter"}>Soll der Benutzer wirklich gelöscht werden?</p>,
				disableOnValue: { key: "id", value: user.id },
				disableOnValues: {
					key: "email",
					values: [
						"support@esch.design",
						"role-admin@esch.design",
						"orga-admin@esch.design",
						"admin@esch.design",
						"cert@esch.design",
						"benutzer@esch.design",
						"fakt-admin@esch.design"
					]
				},
				formFields: [
					{
						name: "sex",
						title: "Anrede",
						type: "custom",
						options: [
							{ value: "n", title: "keine" },
							{ value: "m", title: "Herr" },
							{ value: "f", title: "Frau" }
						],
						className: "col s4 l2"
					},
					{
						name: "forename",
						title: "Vorname",
						type: "custom",
						className: "col s4 l5"
					},
					{
						name: "surname",
						title: "Nachname",
						type: "custom",
						className: "col s4 l5 margin-bottom",
						cleared: true
					},
					{
						name: "organization_id",
						title: "Organisation",
						type: "custom",
						options: organizationOptions,
						className: "col s8 l9"
					},
					{
						name: "role_id",
						title: "Rolle",
						type: "custom",
						options: roleOptions,
						className: "col s4 l3",
						cleared: true
					}
				],
				onClick: ( a_user ) => this.handleDelete( a_user )
			}
		];
		
		
		return users && <article>
			{Configuration.pluginName === "questionnaires" && <QuestionnairePriceBox/>}
			<section className={`${Configuration.pluginName === "questionnaires" ? "marginPrice" : "unset-margin"}`}>
				<h6 className={"col s12 m8 unset-padding margin-top"}>
					In Ihrer Organisation sind
					{
						userCount !== "unlimited" ?
							currentUserCount && userCount &&
							` ${currentUserCount} von ${userCount} Benutzern `
							: ` ${currentUserCount} Benutzer `
					}
					registriert.
				</h6>
				{
					// Einen neuen Benutzer anlegen
					addUser
						? <div className={"col s12 m4 tRight"}>
							<Form
								id={"formAddNewUser"}
								ref={"formAddNewUser"}
								
								modalClass={"tLeft"}
								modalTitle={"Neuen Benutzer anlegen"}
								modalTrigger={
									<button className={"icon-shadow unset-margin"}>
										<Icon key={`form-new-user-icon`} iconName={"add"}/>
										<span key={`form-new-user-text`}>Benutzer anlegen</span>
									</button>
								}
								
								submitValue={[ <Icon key={`form-add-new-user-icon`} iconName={"add"}/>, <span key={`form-add-new-user-text`}>Benutzer anlegen</span> ]}
								errorMessage={( a_message, a_type, a_timeout ) => this.props.message( a_message, a_type, a_timeout )}
								onSubmit={( event ) => this.handleSubmit( event, "formAddNewUser", "create" )}
								fields={[
									{
										name: "email",
										title: "E-Mail-Adresse",
										type: "email",
										required: true,
										className: "col s12 l6",
										cleared: true,
										maxLength: "80"
									},
									{
										name: "sex",
										title: "Anrede",
										type: "select",
										options: [
											{ value: "n", title: "keine" },
											{ value: "m", title: "Herr" },
											{ value: "f", title: "Frau" }
										],
										required: true,
										className: "col s4 l2"
									},
									{
										name: "forename",
										title: "Vorname",
										type: "text",
										required: true,
										className: "col s4 l5",
										maxLength: "80"
									},
									{
										name: "surname",
										title: "Nachname",
										type: "text",
										required: true,
										className: "col s4 l5"
									},
									{
										name: "role_id",
										title: "Rolle",
										type: "select",
										options: roleOptions,
										required: true,
										className: "col s6"
									},
									{
										name: "organization_id",
										title: "Organisation",
										type: "select",
										options: organizationOptions,
										disabled: !Access.isPermitted( user, [ "super_user_permissions" ] ),
										required: true,
										className: "col s6"
									}
								]}
								values={values}
							/>
						</div>
						: <button className={"btn disabled right"} onClick={( a_event ) =>
						{
							a_event.preventDefault();
							this.props.message( "Sie können keine weiteren Nutzer anlegen." );
						}}>
							<Icon key={`form-new-user-icon`} iconName={"add"}/>
							<span key={`form-new-user-text`}>Benutzer anlegen</span>
						</button>
				}
			</section>
			<section className={"white"}>
				{
					Object.keys( userOverview ).length > 0 &&
					<div className={"col s12"}>
						<Overview title={"Aktive Benutzer"}
						          subTitle={`(${Object.keys( userOverview ).length})`}
						          list={userOverview}
						          sortBy={"email"}
						          className={"hidden-buttons unset-margin"}
						          classNameItem={"white-grey"}
						          classNameDataBlock={"col s12 l10 unset-padding"}
						          classNameTriggerBlock={"col s12 l2 tRight"}
						          permissionsToShow={[ "get_users" ]}
						          listFields={listFields}
						          trigger={trigger}
						          expanded
						/>
					</div>
				}
				{
					Object.keys( inactiveUserOverview ).length > 0 &&
					<div className={"col s12"}>
						<Overview title={"Inaktive Benutzer"}
						          subTitle={`(${Object.keys( inactiveUserOverview ).length})`}
						          list={inactiveUserOverview}
						          sortBy={"email"}
						          className={"hidden-buttons unset-margin"}
						          classNameItem={"white-grey"}
						          classNameDataBlock={"col s12 l10 unset-padding"}
						          classNameTriggerBlock={"col s12 l2 tRight"}
						          permissionsToShow={[ "get_users" ]}
						          listFields={listFields}
						          trigger={trigger}
						          expanded
						/>
					</div>
				}
				{
					Object.keys( customerOverview ).length > 0 &&
					<div className={"col s12"}>
						<Overview title={"Kundenbenutzerliste"}
						          subTitle={`(${Object.keys( customerOverview ).length})`}
						          list={customerOverview}
						          groupBy={"organization"}
						          sortBy={"email"}
						          className={"hidden-buttons unset-margin"}
						          classNameItem={"white-grey"}
						          classNameDataBlock={"col s12 l10 unset-padding"}
						          classNameTriggerBlock={"col s12 l2 tRight"}
						          permissionsToShow={[ "get_restricted_users" ]}
						          listFields={listFields}
						          trigger={trigger}
						/>
					</div>
				}
				{
					Object.keys( inactiveCustomerOverview ).length > 0 &&
					<div className={"col s12"}>
						<Overview title={"Kundenbenutzerliste (inaktive)"}
						          subTitle={`(${Object.keys( inactiveCustomerOverview ).length})`}
						          list={inactiveCustomerOverview}
						          groupBy={"organization"}
						          sortBy={"email"}
						          className={"hidden-buttons unset-margin"}
						          classNameItem={"white-grey"}
						          classNameDataBlock={"col s12 l10 unset-padding"}
						          classNameTriggerBlock={"col s12 l2 tRight"}
						          permissionsToShow={[ "get_restricted_users" ]}
						          listFields={listFields}
						          trigger={trigger}
						/>
					</div>
				}
				{/* Benutzerliste */}
				{/*<div className={"col s12"}>
				 {activeUsersIds.length > 0 && this.renderUsers( activeUsersIds, "Aktive Benutzer" )}
				 </div>
				 <div className={"col s12"}>
				 {inactiveUsersIds.length > 0 && this.renderUsers( inactiveUsersIds, "Inaktive Benutzer", "secondary-color" )}
				 </div>*/}
			</section>
		</article>;
		
	} // function render()
	
} // class

UserManagement = connect(
	mapStateToProps,
	mapDispatchToProps
)( UserManagement );

export default UserManagement;
